import React, { useMemo } from 'react'
import { Form } from 'react-bootstrap'
import { useCookies } from 'react-cookie'
import { useGetResolvedQuotasQuery } from '../../store/account/account'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import styled from 'styled-components'
export interface AdvancedModeSwitchProps {}

const CONSOLE_APP_URL = import.meta.env.REACT_APP_CONSOLE_APP_URL!
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

const StyledSwitchWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
  padding: 0.75rem 0;
  border-radius: 0.5rem;
  border: 1px solid var(--zocks-gray-800);
  background: var(--zocks-gray-900, #212529);
`
export const AdvancedModeSwitch: React.FC<AdvancedModeSwitchProps> = () => {
  const accountId = useAppSelector(selectAccountId)!
  const { data: quotas, isSuccess: quotaSuccess } = useGetResolvedQuotasQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const [, setCookie] = useCookies()

  const handleAppSwitch = () => {
    setCookie('preferredAppVersion', 'console', { path: '/', maxAge: COOKIE_MAX_AGE })
    window.location.href = CONSOLE_APP_URL
  }

  const accessToAdvanced = useMemo(() => {
    return quotas && quotas.data.app.advancedConsole.value
  }, [quotas])

  return quotaSuccess && accessToAdvanced ? (
    <StyledSwitchWrapper>
      <div className='lead-small zocks-text-white zocks-px-0.75'>Advanced</div>
      <div className='d-flex gap-3 align-items-center zocks-px-0.75 grayscale-switch'>
        <label htmlFor='version-switch' className='paragraph-small zocks-text-white'>
          Show the advanced view
        </label>
        <Form.Check
          type='switch'
          id='version-switch'
          onChange={() => {
            handleAppSwitch()
          }}
        />
      </div>
    </StyledSwitchWrapper>
  ) : (
    <></>
  )
}
